import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// stock_reservations — จองสินค้าเพื่อ ATP (does not change on-hand)
// ============================================================================
export const stockReservations = sqliteTable("inventory_stock_reservations", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  itemId: text("item_id").notNull(),
  warehouseId: text("warehouse_id").notNull(),
  sourceModule: text("source_module").notNull(),
  sourceDoctype: text("source_doctype").notNull(),
  sourceId: text("source_id").notNull(),
  sourceLineId: text("source_line_id"),
  reservedQty: real("reserved_qty").notNull().default(0),
  status: text("status", {
    enum: ["active", "consumed", "released", "cancelled"],
  }).notNull().default("active"),
  reservationDate: text("reservation_date").notNull(),
  expiresAt: text("expires_at"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at"),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  sr_item_wh_idx: index("sr_item_wh_idx").on(table.companyId, table.itemId, table.warehouseId, table.status),
  sr_source_idx: index("sr_source_idx").on(table.companyId, table.sourceModule, table.sourceDoctype, table.sourceId),
}));

// ============================================================================
// stock_backorders — จำนวนที่จัดสรรไม่ได้ ณ ตอนวางแผน
// ============================================================================
export const stockBackorders = sqliteTable("inventory_stock_backorders", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  itemId: text("item_id").notNull(),
  warehouseId: text("warehouse_id").notNull(),
  sourceModule: text("source_module").notNull(),
  sourceDoctype: text("source_doctype").notNull(),
  sourceId: text("source_id").notNull(),
  sourceLineId: text("source_line_id"),
  requestedQty: real("requested_qty").notNull().default(0),
  availableQty: real("available_qty").notNull().default(0),
  backorderQty: real("backorder_qty").notNull().default(0),
  fulfilledQty: real("fulfilled_qty").notNull().default(0),
  status: text("status", {
    enum: ["open", "fulfilled", "cancelled"],
  }).notNull().default("open"),
  expectedDate: text("expected_date"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at"),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  sb_item_wh_idx: index("sb_item_wh_idx").on(table.companyId, table.itemId, table.warehouseId, table.status),
  sb_source_idx: index("sb_source_idx").on(table.companyId, table.sourceModule, table.sourceDoctype, table.sourceId),
}));

export type StockReservation = typeof stockReservations.$inferSelect;
export type NewStockReservation = typeof stockReservations.$inferInsert;
export type StockBackorder = typeof stockBackorders.$inferSelect;
export type NewStockBackorder = typeof stockBackorders.$inferInsert;
